import inboxRuleStore from '../store/store';
import { trace } from 'owa-trace';
import { action, select } from 'satcheljs/lib/legacy';
import { format } from 'owa-strings';
/**
 * Validate the old and new create rule request states are expected
 * @param oldStatus current create rule request status in store
 * @param newStatus the create rule request status to be set
 */
function validateInboxRuleRequestState(oldStatus, newStatus) {
    var errorStr = 'Invalid state transition {0} to {1}';
    if (newStatus == 1 /* Pending */ &&
        (oldStatus == 1 /* Pending */ ||
            oldStatus == 2 /* Complete */)) {
        trace.error(format(errorStr, oldStatus, newStatus));
    }
    if ((newStatus == 2 /* Complete */ ||
        newStatus == 3 /* Error */) &&
        oldStatus != 1 /* Pending */) {
        trace.error(format(errorStr, oldStatus, newStatus));
    }
}
/**
 * Set the InboxRuleRequestStatus in create rule store
 * @param requestStatus the create rule request status to set
 * @param state the state which contains the create rule store
 */
export default action('setInboxRuleRequestStatus')(select({
    inboxRuleStore: function () { return inboxRuleStore; },
})(function setInboxRuleRequestStatus(requestStatus, state) {
    var inboxRuleStore = state.inboxRuleStore;
    if (!inboxRuleStore.isInboxRuleDialogShown) {
        // Do nothing if the create rule dialog is hidden when try setting InboxRuleRequestStatus, e.g. user dismisses the
        // dialog when the request is outstanding.
        return;
    }
    validateInboxRuleRequestState(inboxRuleStore.inboxRuleRequestStatus, requestStatus);
    inboxRuleStore.inboxRuleRequestStatus = requestStatus;
}));
//# sourceMappingURL=setInboxRuleRequestStatus.js.map